export const NOTIFICATIONS_UPDATE = 'NOTIFICATIONS_UPDATE'
